var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopoverArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.2,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0,0,0,0.2)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    filter: "url(#shadow)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0L7.41421 4.58579C6.63317 5.36683 5.36684 5.36684 4.58579 4.58579L0 0H12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopoverArrow);
export default __webpack_public_path__ + "static/media/popoverArrow.11182a4e180774a11837194af8dd355f.svg";
export { ForwardRef as ReactComponent };